import React from 'react'
import CreditImg from '../../Images/CreditImg/AakasmikLoan.jpg'
import SideNavCredit from '../Navigation/SideNavCredit'
import Aos from 'aos'

const AakasmikLoan = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNavCredit />
                    </div>
                    <div className='d-body-main'>
                        <div className='saving-body-top' data-aos='fade-right'>
                            <h2>आकस्मिक ऋण</h2>
                        </div>
                        <div className='saving-body' data-aos='fade-right'>
                            <div className='saving-main'>
                                <h3>विवरण :</h3>
                                <p>
                                    <ul>
                                        <li>संकेत नंः ११०.१३</li>
                                        <li>ऋणको उद्देश्यः सदस्यलाई बिरामी तथा विपतमा सहयोग पुर्याउने ।  </li>
                                        <li>ऋणको सिमाः अधिकतम रु. २५,०००  सम्म ।</li>
                                        <li>ब्याजदरः संस्थाले तोके बमोजिम ।</li>
                                        <li>किस्ताः अर्धवार्षिक वा एकमुष्ठ ।</li>
                                        <li>समयावधिः १ वर्ष / २ महिना</li>
                                        <li>धितो व्यवस्थाः विना धितो </li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg' data-aos='fade-right'>
                                <img src={CreditImg} alt='Credit-1' />
                            </div>
                        </div>
                        <div className='saving-footer' data-aos='fade-right'>
                            <h3>विशेषताहरू :</h3>
                            <p>
                                <ul>
                                    <li>सदस्य वा सदस्यको परिवारमा दुर्घटना परेमा, सर्पले टोकेमा, दैबी प्रकोपका कारण नोक्सानी भएमा तथा अन्य विपत आई परेमा ऋण प्राप्त गर्न सकिने ।</li>
                                    <li>एक मुष्ठ किस्ता असुल गर्नुपर्ने । </li>
                                    <li>समयभित्र बुझाएमा साँवा मात्र बुझाउँदा हुने । </li>
                                    <li>समयमा ऋण नतिरेमा भाखा नाघेको ऋणको किस्तामा ५% हर्जना लाग्ने ।</li>
                                    <li>व्यवस्थापन शुल्क नलाग्ने ।</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default AakasmikLoan